import { useRef, useLayoutEffect } from "react";
import { Trans } from "react-i18next";
import { PAGE } from "../constants/page";
import BreadcrumbService from "../services/BreadcrumbsService";
import "../../src/styles/components/Breadcrumbs.scss";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { patientName, updatedPatient } from "../redux/reducers/PatientSlice";
import { updateLanguage } from "../redux/reducers/PersistSlice";
interface breacrumbRoute {
  label_key: string;
  fn: any;
}

interface breadcrumbType {
  routes?: breacrumbRoute[];
  active_key: string;
  navigation?: any;
  location?: string;
}

const Breadcrumbs = (props: breadcrumbType) => {
  const breadcrumbService = BreadcrumbService.instance;
  const dispatch = useAppDispatch();
  const routeLength = props?.routes?.length;
  const toBeFocussed = useRef(null);
  const language = useAppSelector(updateLanguage);

  /*
  I do not see use of this code, so commenting it
  useLayoutEffect(() => {
    // runs everytime the language is switched or the routes props is changed to bring the last item into focus
    scrollBreadcrumbIntoView();
  }, [language.payload.persistDetails.language, props.routes]);
  */
  const handleHomeClick = () => {
    breadcrumbService.advancedSearch = null;
    if (props.navigation && props.location?.indexOf("admin") !== -1) {
      props.navigation(PAGE.GLOBAL_HOME);
    } else {
      props.navigation(PAGE.HOME);
      dispatch(updatedPatient(false));
      dispatch(patientName({ firstName: null, lastName: null }));
    }
  };

  const handleSearchClick = () => {
    breadcrumbService.active_key = props.active_key;
    props.navigation(PAGE.HOME);
  };

  const displayAdvanceSearchResult = (data: any) => {
    let searchResult = false;
    for (const property in data) {
      if (data?.[property] !== "") {
        searchResult = true;
      }
    }
    return searchResult;
  };

  const scrollBreadcrumbIntoView = () => {
    toBeFocussed?.current &&
      (toBeFocussed?.current as unknown as HTMLElement)?.scrollIntoView({
        block: "end",
      });
  };

  const breadItems = () => {
    const advancedSearchJSX = (
      <li className={`item searchResult`} onClick={handleSearchClick}>
        <Trans i18nKey={"search_result"}></Trans>
      </li>
    );

    const activeTextJSX = (noOfItems: string, itemNo: string) => (
      <li
        className={`item ${noOfItems + " " + itemNo} active`}
        aria-current="page"
        ref={toBeFocussed}
      >
        <Trans i18nKey={props.active_key}></Trans>
      </li>
    );

    if (displayAdvanceSearchResult(breadcrumbService?.advancedSearch)) {
      if (props.routes && props.routes.length > 0) {
        //four-item breadcrumb
        return (
          <>
            {advancedSearchJSX}
            {props?.routes?.map((route, index) => (
              <li
                className={`item four-items ${
                  route?.label_key?.indexOf("profile") === -1
                    ? "third-item"
                    : " "
                }`}
                key={`breadcrumb-${index}`}
                onClick={route.fn}
              >
                <Trans i18nKey={route.label_key}></Trans>
              </li>
            ))}
            {activeTextJSX("", "")}
          </>
        );
      } else {
        // four-item breadcrumb in Advanced Search route (but displays only three items)
        return (
          <>
            {advancedSearchJSX}
            {activeTextJSX("four-items", "third-item")}
          </>
        );
      }
    } else {
      if (props.routes && props.routes.length > 0) {
        // three-item breadcrumb
        return (
          <>
            {props?.routes?.map((route, index) => (
              <li
                className={`item three-items ${
                  route?.label_key?.indexOf("profile") === -1
                    ? "second-item"
                    : " "
                }`}
                key={`breadcrumb-${index}`}
                onClick={route.fn}
              >
                <Trans i18nKey={route.label_key}></Trans>
              </li>
            ))}
            {activeTextJSX("", "")}
          </>
        );
      } else {
        //two-item breadcrumb
        return (
          <li
            className={`item two-items second-item`}
            aria-current="page"
            ref={toBeFocussed}
          >
            <Trans i18nKey={props.active_key}></Trans>
          </li>
        );
      }
    }
  };

  return (
    <nav>
      <div className="patient-breadcrumb-outer">
        <ol className="breadcrumb container text-capitalize">
          <li className="item home" onClick={handleHomeClick}>
            <Trans i18nKey={"home"}></Trans>
          </li>
          {breadItems()}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;
